import { render, staticRenderFns } from "./SelectorVehicleCategory.vue?vue&type=template&id=62a0de3e&scoped=true&"
import script from "./SelectorVehicleCategory.vue?vue&type=script&lang=js&"
export * from "./SelectorVehicleCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a0de3e",
  null
  
)

export default component.exports